import makeStyles from "@mui/styles/makeStyles";
import { StatisticsProps } from "./Statistics.types";

export const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
  },
  rootBullet: {
    paddingLeft: 24,
  },
  value: {
    position: "relative",
  },
  valueBullet: (props: StatisticsProps) => ({
    "&::before": {
      content: "''",
      position: "absolute",
      top: "calc(50% - 5px)",
      left: -24,
      width: 12,
      height: 12,
      background: props.bulletColor,
      borderRadius: 999,
    },
  }),
  content: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    fontSize: "12px",
  },
  tooltip: {
    marginLeft: 4,
    marginTop: -3,
    "& > svg": {
      fill: theme.palette.grey[600],
    },
  },
}));
